import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'

const VehicleDetails = ({
  vehicleNickName,
  frontSize,
  rearSize
}) =>
  <VehicleBlock>
    <VehicleName>{ vehicleNickName }</VehicleName>
    <TireSizes>
      { rearSize && 'Front Size: '}
      { frontSize }
      { rearSize && ` Rear Size: ${rearSize}`}
    </TireSizes>
  </VehicleBlock>

VehicleDetails.propTypes = {
  frontSize: PropTypes.string,
  rearSize: PropTypes.string,
  vehicleNickName: PropTypes.string
}

export default VehicleDetails

const VehicleBlock = styled.div`
  border: 1px solid ${Theme.colors.light_grey};
  border-bottom: none;
  padding: 10px 15px;
`

const VehicleName = styled.span`
  display: block;
  ${Mixin.font.GothamBold(20)}
  margin-bottom: 10px;
  text-transform: capitalize;
  ${Mixin.ellipsis()}
`

const TireSizes = styled.span`
  ${Mixin.responsive('font-size', '15px', '13px')}
`
